import styled from "styled-components";

export const FieldContainer = styled.div`
margin: 1em 0;
`;
export const Label = styled.div`
    color:#333;
`;